export const baseEnv = window.baseEnv;
export const isProduction = baseEnv === 'production';
export const baseUrl = window.baseUrl;
export const baseApiUrl = window.baseApiUrl;

export const cabinetUrl = 'https://mostcrm.ru/cabinet';
